// Axios
import axios from "src/lib/axios"

// --------------------------------------------|| PROFILE - SERVICES || -------------------------------------------

const getProfileData = () => {
  return axios.get("/api/v1/account/getProfile")
}

const profileServices = { getProfileData }

export default profileServices
